import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  submittedTabValue: 1,
  viewOrderTab: 0,
  loading: false,
  error: null,
  success: false,
  fileSummaryDetails:null,
  WSRequestlogID:0,
  systemVariableValue:"",
  screenZoomedIn: false,
  closingDateDetails: null,
};

// our slice
const orderSlice = createSlice({
  name: "ordersSlice",
  initialState,
  reducers: {
    setSucessTab: (state, { payload }) => {
      // if (payload > state.submittedTabValue) {
      state.submittedTabValue = payload;
      // }
    },
    setViewOrderTab: (state, { payload }) => {
      state.viewOrderTab = payload;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setfileSummaryDetails: (state, { payload }) => {
      state.loading = false;
      state.fileSummaryDetails = payload;
      state.success = true;
    },
    setWSRequestLogID: (state, { payload }) => {
      state.loading = false;
      state.WSRequestlogID = payload;
      state.success = true;
    },
    setsystemVariableValue: (state, { payload }) => {
      state.loading = false;
      state.systemVariableValue = payload;
      state.success = true;
    },
    setScreenZoomedIn: (state, {payload}) => {
      state.screenZoomedIn = payload;
    },
    setClosingDateDetails: (state, { payload }) => {
      state.loading = false;
      state.closingDateDetails = payload;
      state.success = true;
    },
  },
});

// export the actions
export const { setSucessTab,setViewOrderTab ,setError,setSuccess,setLoading,setfileSummaryDetails,setWSRequestLogID,setsystemVariableValue, setScreenZoomedIn,setClosingDateDetails} = orderSlice.actions;

export const orderSliceSelector = (state) => state.ordersSlice;


export const UpdateFileDetailsExpress = (FileID,multiFiles,IsPickupConfirmed,Notetext,UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID,
      MultifileID:multiFiles,
      IsPickupConfirmed:IsPickupConfirmed,
      Notetext:Notetext,
      userID:UserID
    };

    let req = { UserID: UserID, RequestObject: request };
    const results = await http
      .post('Order/UpdateFileDetailsExpress', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const GetFileSummaryExpress = (FileID,userID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID
    };

    let req = { UserID: userID, RequestObject: request };
    const results = await http
      .post('Order/GetFileSummaryExpress', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setfileSummaryDetails(results.data.responseObject))
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const GetSystemVariableValue = (variableName) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      variableName: variableName
    };

    // let req = { UserID: userID, RequestObject: request };
    let req = {  RequestObject: request };
    const results = await http
      .post('Order/GetVariableValueByName', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setsystemVariableValue(results.data.responseObject))
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const InsertWSrequestLog = (requestString,userID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      request: requestString
    };

    let req = { UserID: userID, RequestObject: request };
    const results = await http
      .post('Order/InsertWSRequestLog', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setWSRequestLogID(results.data.responseObject.logID))
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const updateWSrequestLog = (logID,fileID,response,note,logCode,method,referenceNumber,userID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      logID: logID,
      fileID: fileID,
      response: response,
      note: note,
      logCode: logCode,
      method: method,
      referenceNumber: referenceNumber,
    };

    let req = { UserID: userID, RequestObject: request };
    const results = await http
      .post('Order/UpdateWSRequestLog', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      //dispatch(setWSRequestLogID(results.data.responseObject))
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const updateFileStatus = (fileID,status,userID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      fileID:fileID,
      status:status,
      userID:userID,
    };

    let req = { UserID: userID, RequestObject: request };
    const results = await http
      .post('Order/UpdateFileStatusExpress', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
     
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetClosingDateDetails = (FileID,userID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID
    };

    let req = { UserID: userID, RequestObject: request };
    const results = await http
      .post('Order/GetClosingDateDetailsByFileIDExpress', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setClosingDateDetails(results.data.responseObject))
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};


// export the default reducer
export default orderSlice.reducer;
